import { render, staticRenderFns } from "./attrValueManage.vue?vue&type=template&id=3371c643&scoped=true"
import script from "./attrValueManage.vue?vue&type=script&lang=js"
export * from "./attrValueManage.vue?vue&type=script&lang=js"
import style0 from "./attrValueManage.vue?vue&type=style&index=0&id=3371c643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371c643",
  null
  
)

export default component.exports